import { Ray } from "@babylonjs/core/Culling/ray";
import { Plane } from "@babylonjs/core/Maths/math.plane";
import { Matrix, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { TransformElements } from "../../core/cmd/TransformElements";
import { AbstractTool } from "../../core/tool/AbstractTool";
import { InteractionMode } from "../../core/tool/Tool";
import { intersectRayPlane, VECTOR3_Y } from "../../core/utils/MathUtils";
import { CoordinatesType } from "../../core/view/View";
import { Log } from "../../utils";
import { eq } from "../../utils/math";
export class AbstractRotate extends AbstractTool {
    constructor(pApp) {
        super(pApp);
        this.mRefPoint = Vector3.Zero();
        this.mTransformedRefPoint = Vector3.Zero();
        this.mLocalRotation = true;
        this.mAxisVector = VECTOR3_Y;
        this.mCommand = null;
        this.mIsFinished = false;
        this.mTotalAngle = 0;
        this.mPickPlane = null;
        this.mView = this.mApp.viewer.view;
    }
    start(pParameter) {
        this.mIsFinished = false;
        this.mTotalAngle = 0;
        this.mCommand = new TransformElements(this.mApp, this.mApp.model.selection);
        this.mLocalRotation = this.mApp.model.selection.length === 1;
        let tPlaneNormal = null;
        if (this.mLocalRotation) {
            let tTransform = this.mApp.model.selection[0].worldTransform;
            tPlaneNormal = Vector3.TransformNormal(this.mAxisVector, tTransform);
            tTransform = Matrix.Invert(tTransform);
            this.mTransformedRefPoint = Vector3.TransformCoordinates(this.mRefPoint, tTransform);
        }
        else {
            this.mTransformedRefPoint = this.mRefPoint;
            tPlaneNormal = this.mAxisVector;
        }
        this.mPickPlane = Plane.FromPositionAndNormal(this.mRefPoint, tPlaneNormal);
        this.setInteractionMode(InteractionMode.Primary);
        return (super.start(pParameter));
    }
    stop() {
        if (!this.mIsFinished && this.mCommand != null)
            this.mCommand.undoTransforms();
        this.mCommand = null;
        super.stop();
    }
    handlePointerUp(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent))
            return;
        this.mIsFinished = true;
        if (eq(this.mTotalAngle, 0)) {
            this.stop();
        }
        else {
            this.mApp.commands.executeCommand(this.mCommand).then((pExecuted) => {
                this.stop();
            }).catch((pError) => {
                Log.error("Failed to execute TransformElements command.", pError);
            });
        }
    }
    getPlanePickPos(pPos) {
        if (this.mPickPlane == null)
            return (null);
        this.mView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
        return (intersectRayPlane(gTmpRay, this.mPickPlane));
    }
}
//// temp variables ////////////////////////////////////////////////////////////////////////////
const gTmpRay = Ray.Zero();
